export default "__VITE_ASSET__bde15edb__"